import { siteLinks } from "../../data/site.js";

export function Hero() {
  return `
    <section class="hero" aria-labelledby="hero-title">
      <div class="hero-orb hero-orb-one" aria-hidden="true"></div>
      <div class="hero-orb hero-orb-two" aria-hidden="true"></div>
      <div class="site-container hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker"><i></i> Tecnología empresarial · República Dominicana</span>
          <h1 id="hero-title">Software empresarial para organizar, automatizar y hacer crecer tu operación.</h1>
          <p>Desarrollamos productos conectados para administrar proyectos, facturación electrónica, operaciones, documentos y procesos empresariales desde una sola visión tecnológica.</p>
          <div class="hero-actions">
            <a class="button button-primary" href="/#productos" data-route>Explorar productos</a>
            <a class="button button-secondary" href="${siteLinks.requestDemo}">Solicitar demostración</a>
          </div>
          <div class="hero-proof" aria-label="Enfoque de GR SoftMedia">
            <span>Productos propios</span><span>Integraciones reales</span><span>Implementación acompañada</span>
          </div>
        </div>
        <div class="hero-visual" aria-label="Vistas de productos GR SoftMedia">
          <div class="hero-dashboard hero-dashboard-main">
            <div class="preview-browser" aria-hidden="true"><span></span><span></span><span></span><b>InnoProject</b></div>
            <img src="/assets/products/innoproject-dashboard.png" alt="Dashboard de InnoProject" width="1440" height="1050" fetchpriority="high" />
          </div>
          <div class="hero-dashboard hero-dashboard-float hero-dashboard-admin">
            <span>Administración</span><strong>InnoAdmin</strong><small>Operación y finanzas conectadas</small>
          </div>
          <div class="hero-dashboard hero-dashboard-float hero-dashboard-ecf">
            <span>Facturación electrónica</span><strong>Inno e-CF</strong><small>Seguimiento de comprobantes</small>
          </div>
          <div class="hero-status"><i></i><span>Ecosistema conectado</span></div>
        </div>
      </div>
    </section>
  `;
}
